import { BaseException } from "@/exceptions/base-exception.exception.ts"
import { ExceptionWeights } from "@/enums/exceptions/exception-weights.ts"
import { Activity } from "@/models/activity.model.ts"
import type { Moment } from "moment"
import moment from "moment"

export class ActivityOutOfWorkPeriodException extends BaseException {
  exceptionId = "ACTIVITY_OUT_OF_WORK_PERIOD"
  title = "Activiteit buiten dienst"
  weight = ExceptionWeights.ERROR

  private readonly violatingActivities?: Activity[]
  private readonly workPeriodStart: Moment
  private readonly workPeriodEnd?: Moment

  constructor(
    violatingActivities: Activity[] | undefined,
    workPeriodStart: string,
    workPeriodEnd: string
  ) {
    super()
    if (violatingActivities) {
      this.violatingActivities = violatingActivities.map((activity) => new Activity(activity))
    }
    this.workPeriodStart = moment(workPeriodStart)
    this.workPeriodEnd = workPeriodEnd ? moment(workPeriodEnd) : undefined
  }

  public getMessage(): string {
    const { violatingActivities, workPeriodStart, workPeriodEnd } = this

    if (violatingActivities) {
      if (violatingActivities.length === 1) {
        const activity = violatingActivities[0]
        const workPeriodEndStr = workPeriodEnd ? ` tot ${workPeriodEnd.format("HH:mm")} uur` : ""
        return `De activiteit ${activity.getTypeString()} van ${activity.timeStart?.format("HH:mm")} uur tot ${activity.timeEnd?.format("HH:mm")} uur valt buiten de dienst van ${workPeriodStart.format("HH:mm")} uur${workPeriodEndStr}.`
      }

      return `Activiteiten vallen buiten de dienst:
            ${violatingActivities
              .map((activity) => {
                return `- ${activity.timeStart?.format("HH:mm")} uur tot ${activity.timeEnd?.format("HH:mm")} uur`
              })
              .join("\n")}`
    }
    return "De activiteit valt buiten je dienst. Pas eerst je diensttijden aan."
  }
}
